import React, { useState } from "react";
import { Box, Typography, Button, Paper, Container } from "@mui/material";
import { FaArrowRight } from "react-icons/fa";
import Popup from "./Popup";

const NewsletterSignup = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box
      sx={{
        py: 10,
        px: { xs: 4, sm: 4, md: 6 },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div>
        <Popup open={open} handleClose={handleClose} />
      </div>
      <Paper
        sx={{
          bgcolor: "black",
          color: "white",
          py: { xs: 6, md: 12 },
          px: { xs: 2, md: 12 },
          borderRadius: 4,
          width: { xs: "100%", md: "80%" },
          maxWidth: "1200px",
          marginX: "auto",
        }}
      >
        <Container maxWidth="md">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
          >
            <Typography
              variant="h4"
              component="h2"
              fontWeight="500"
              gutterBottom
              sx={{ mb: 4 }}
            >
              Get your free report to stay up to date on
              <br />
              the Dubai property market.
            </Typography>
            <Button
              onClick={handleOpen}
              variant="contained"
              sx={{
                bgcolor: "white",
                color: "black",
                borderRadius: 10,
                px: 3,
                py: 1.5,
                "&:hover": {
                  bgcolor: "rgba(255, 255, 255, 0.9)",
                },
                minWidth: { sm: "180px" },
              }}
              endIcon={<FaArrowRight size={16} />}
            >
              Get Free Report
            </Button>
          </Box>
        </Container>
      </Paper>
    </Box>
  );
};

export default NewsletterSignup;
